import { FC, HTMLAttributes, useCallback } from 'react'
import tw from 'tailwind-styled-components'
import { CheckBox } from './Inputs/CheckBox'

type Value = string
type Option = {
  label: string
  value: Value
}
type Props = Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> & {
  options: Option[]
  selected: Value[]
  onChange(value: Value[]): void
}

const Container = tw.div`flex flex-col space-y-4`

const Item: FC<Option & { onChange(value: string): void; selected: boolean }> = ({
  label,
  value,
  onChange,
  selected,
}) => {
  const handleChange = useCallback(() => onChange(value), [onChange, value])

  return <CheckBox name={value} label={label} checked={selected} onChange={handleChange} />
}

export const MultiSelectList: FC<Props> = ({ options, selected, onChange, ...props }) => {
  const handleChange = useCallback(
    (value: Value) => {
      const values = selected.includes(value)
        ? selected.filter((item) => item !== value)
        : [...selected, value]

      onChange(values)
    },
    [onChange, selected]
  )

  return (
    <Container {...props}>
      {options.map(({ label, value }) => (
        <Item
          key={value}
          onChange={handleChange}
          label={label}
          value={value}
          selected={selected.includes(value)}
        />
      ))}
    </Container>
  )
}
